import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';
import { initPrefs } from './prefs';
import { initTelemetry } from './telemetry';

initTelemetry();
initPrefs(); // theme, accent and language before first paint

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
